export const ConditionsMessagesBranchement = [
  `Assurez-vous de disposer de votre pièce d'identité,du document relatif à votre parcelle, des informations cadastrales de celle-ci, ainsi que de connaître le type de branchement et l'ampérage souhaité.`,
  `La SONABEL décline toute responsabilité pour toute inexactitude des informations fournies par les demandeurs.`,
  `Aucun remboursement ne sera accordé en cas de fausses informations. La SONABEL se réserve le droit de poursuivre en justice les cas de fraude.`
];

export const ConditionsMessagesAbonnement  = [ 
    `Assurez-vous d'avoir votre pièce d'identité,votre reçu de branchement avec le numéro, et surtout que le branchement soit effectué.`,
    `La SONABEL décline toute responsabilité pour toute inexactitude des informations fournies par les demandeurs.`,
    `Aucun remboursement ne sera accordé en cas de fausses informations. La SONABEL se réserve le droit de poursuivre en justice les cas de fraude.`
];

export const CondtionsMessagesTD = [
    `Assurez-vous d'avoir le numéro de compteur pour les prépayés, ainsi que le numéro de police et le numéro d'exploitation pour les postpayés.`,
    `La SONABEL décline toute responsabilité pour toute inexactitude des informations fournies par les demandeurs.`,
    `Aucun remboursement ne sera accordé en cas de fausses informations. La SONABEL se réserve le droit de poursuivre en justice les cas de fraude.`
];
